"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangePickerComponent = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var core_1 = require("@emotion/core");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var foundation_1 = require("../../theme/foundation");

var input_field_component_1 = require("./input-field.component");

var date_picker_component_1 = require("./date-picker.component");

var moment_1 = __importDefault(require("moment"));

var core_2 = require("@material-ui/core");

exports.DateRangePickerComponent = utils_2.forwardRef(function DateRangePickerComponent(props, ref) {
  var onChange = props.onChange,
      format = props.format,
      value = props.value,
      _a = props.width,
      width = _a === void 0 ? '100%' : _a,
      placeholder = props.placeholder,
      showIcon = props.showIcon;

  var _b = React.useState(false),
      open = _b[0],
      setOpen = _b[1];

  var _c = React.useState(),
      tmpFromDate = _c[0],
      setTmpFromDate = _c[1];

  var _d = React.useState(),
      tmpToDate = _d[0],
      setTmpToDate = _d[1];

  var _e = React.useState(),
      fromDate = _e[0],
      setFromDate = _e[1];

  var _f = React.useState(),
      toDate = _f[0],
      setToDate = _f[1];

  var pickerRef = React.useRef();
  var customTheme = core_2.createMuiTheme({
    palette: {
      primary: {
        main: '#22AA5F',
        light: '#22AA5F',
        dark: '#22AA5F'
      },
      secondary: {
        main: '#22AA5F'
      }
    }
  });
  var datepickerContainer = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\twidth: 100%;\n\t\tmax-width: 750px;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tborder-radius: 4px;\n\t\tbackground: ", ";\n\n\t\t.MuiFormControl-root {\n\t\t\t// width: $ {width} !important;\n\t\t}\n\t"], ["\n\t\twidth: 100%;\n\t\tmax-width: 750px;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tborder-radius: 4px;\n\t\tbackground: ", ";\n\n\t\t.MuiFormControl-root {\n\t\t\t// width: $ {width} !important;\n\t\t}\n\t"])), foundation_1.colors.white);
  var inputContainer = core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\twidth: ", "!important;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tbackground: ", ";\n\t"], ["\n\t\twidth: ", "!important;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tbackground: ", ";\n\t"])), width, foundation_1.colors.white);
  var pickersContainer = core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\twidth: 750px;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tbackground: ", ";\n\t\tbox-shadow: 0 4px 1.25em #ebeeef;\n\t\tpadding: 1em;\n\t"], ["\n\t\twidth: 750px;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tbackground: ", ";\n\t\tbox-shadow: 0 4px 1.25em #ebeeef;\n\t\tpadding: 1em;\n\t"])), foundation_1.colors.white);
  var pickerOverride = core_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t\t.MuiPickersDay-daySelected {\n\t\t\tbackground-color: ", "!important;\n\t\t}\n\n\t\t.MuiPickersCalendarHeader-dayLabel {\n\t\t\tcolor: #1a2834 !important;\n\t\t\tfont-size: 0.75em !important;\n\t\t\tfont-weight: 600 !important;\n\t\t}\n\n\t\t.MuiTypography-root MuiTypography-body2 {\n\t\t\tfont-weight: 600 !important;\n\t\t\tcolor: #54666f !important;\n\t\t\tfont-size: 0.75em !important;\n\t\t}\n\n\t\t.MuiPickersCalendarHeader-transitionContainer > p {\n\t\t\tfont-weight: 800 !important;\n\t\t\tcolor: #54666f !important;\n\t\t\tfont-size: 1.125em !important;\n\t\t}\n\n\t\t.MuiInputBase-input {\n\t\t\tborder: solid 1px #e3e6e8 !important;\n\t\t\tborder-radius: 4px !important;\n\t\t\twidth: 100% !important;\n\t\t\tpadding: 0.875em 1em !important;\n\t\t\tjustify-content: space-between !important;\n\t\t\tmin-height: 45px;\n\t\t\ttransition: all 0.1s ease-in-out !important;\n\n\t\t\t&:focus {\n\t\t\t\toutline: none;\n\t\t\t}\n\t\t}\n\n\t\t.MuiInput-underline:before,\n\t\t.MuiInput-underline:after {\n\t\t\tdisplay: none !important;\n\t\t}\n\n\t\t.MuiIconButton-label > svg {\n\t\t\tcolor: #22aa5f;\n\t\t\tfont-size: 0.675em !important;\n\t\t}\n\n\t\t.MuiInputAdornment-positionEnd {\n\t\t\tmargin-left: -2.313em !important;\n\t\t}\n\n\t\t.MuiTouchRipple-root {\n\t\t\tdisplay: none !important;\n\t\t}\n\n\t\t.MuiIconButton-root:hover {\n\t\t\tbackground-color: transparent !important;\n\t\t}\n\n\t\t.MuiGrid-spacing-xs-3 > .MuiGrid-item {\n\t\t\tpadding-left: 0.625em !important;\n\t\t\tpadding-right: 0.625em !important;\n\t\t\tpadding-top: 0.938em !important;\n\t\t\tpadding-bottom: 0.938em !important;\n\t\t}\n\n\t\t.MuiFormControl-marginNormal {\n\t\t\tmargin: 0 !important;\n\t\t}\n\t"], ["\n\t\t.MuiPickersDay-daySelected {\n\t\t\tbackground-color: ", "!important;\n\t\t}\n\n\t\t.MuiPickersCalendarHeader-dayLabel {\n\t\t\tcolor: #1a2834 !important;\n\t\t\tfont-size: 0.75em !important;\n\t\t\tfont-weight: 600 !important;\n\t\t}\n\n\t\t.MuiTypography-root MuiTypography-body2 {\n\t\t\tfont-weight: 600 !important;\n\t\t\tcolor: #54666f !important;\n\t\t\tfont-size: 0.75em !important;\n\t\t}\n\n\t\t.MuiPickersCalendarHeader-transitionContainer > p {\n\t\t\tfont-weight: 800 !important;\n\t\t\tcolor: #54666f !important;\n\t\t\tfont-size: 1.125em !important;\n\t\t}\n\n\t\t.MuiInputBase-input {\n\t\t\tborder: solid 1px #e3e6e8 !important;\n\t\t\tborder-radius: 4px !important;\n\t\t\twidth: 100% !important;\n\t\t\tpadding: 0.875em 1em !important;\n\t\t\tjustify-content: space-between !important;\n\t\t\tmin-height: 45px;\n\t\t\ttransition: all 0.1s ease-in-out !important;\n\n\t\t\t&:focus {\n\t\t\t\toutline: none;\n\t\t\t}\n\t\t}\n\n\t\t.MuiInput-underline:before,\n\t\t.MuiInput-underline:after {\n\t\t\tdisplay: none !important;\n\t\t}\n\n\t\t.MuiIconButton-label > svg {\n\t\t\tcolor: #22aa5f;\n\t\t\tfont-size: 0.675em !important;\n\t\t}\n\n\t\t.MuiInputAdornment-positionEnd {\n\t\t\tmargin-left: -2.313em !important;\n\t\t}\n\n\t\t.MuiTouchRipple-root {\n\t\t\tdisplay: none !important;\n\t\t}\n\n\t\t.MuiIconButton-root:hover {\n\t\t\tbackground-color: transparent !important;\n\t\t}\n\n\t\t.MuiGrid-spacing-xs-3 > .MuiGrid-item {\n\t\t\tpadding-left: 0.625em !important;\n\t\t\tpadding-right: 0.625em !important;\n\t\t\tpadding-top: 0.938em !important;\n\t\t\tpadding-bottom: 0.938em !important;\n\t\t}\n\n\t\t.MuiFormControl-marginNormal {\n\t\t\tmargin: 0 !important;\n\t\t}\n\t"])), foundation_1.colors.primary.green);

  var renderInput = function renderInput() {
    return (0, _core.jsx)(input_field_component_1.InputField, {
      placeholder: placeholder,
      value: "" + (tmpFromDate ? moment_1["default"](tmpFromDate).format('DD/MM/YYYY') : '') + (tmpFromDate && tmpToDate ? ' - ' : '') + (tmpToDate ? moment_1["default"](tmpToDate).format('DD/MM/YYYY') : ''),
      trailingIcon: showIcon ? 'calendar-alt' : false,
      white: true,
      onClickTrailingIcon: function onClickTrailingIcon() {
        return setOpen(!open);
      },
      onFocus: function onFocus() {
        return setOpen(true);
      }
    });
  };

  var handleClickOutside = function handleClickOutside(event) {
    var dropDown = pickerRef.current;

    if (!dropDown) {
      return;
    } // @ts-ignore


    if (!dropDown.contains(event.target)) {
      setOpen(false);
    }
  };

  React.useEffect(function () {
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [pickerRef]);
  return (0, _core.jsx)(core_2.MuiThemeProvider, {
    theme: customTheme
  }, (0, _core.jsx)(lseds_1.lseds.div, {
    css: datepickerContainer
  }, (0, _core.jsx)(lseds_1.lseds.div, {
    css: inputContainer
  }, renderInput()), open && (0, _core.jsx)(lseds_1.lseds.div, {
    css: pickersContainer,
    ref: pickerRef
  }, (0, _core.jsx)(date_picker_component_1.DatePicker, {
    InputFieldComponent: renderInput,
    value: fromDate || '',
    onChange: function onChange(e) {
      if (toDate && moment_1["default"](toDate).isAfter(moment_1["default"](e)) || !toDate) {
        setFromDate(moment_1["default"](e));
        setTmpFromDate(moment_1["default"](e));
      }
    },
    format: 'dd/MM/yyyy',
    open: true,
    css: pickerOverride,
    maxDate: toDate || null
  }), (0, _core.jsx)(date_picker_component_1.DatePicker, {
    InputFieldComponent: renderInput,
    value: toDate || '',
    onChange: function onChange(e) {
      if (fromDate && moment_1["default"](fromDate).isBefore(moment_1["default"](e))) {
        setToDate(moment_1["default"](e));
        setTmpToDate(moment_1["default"](e));
      }
    },
    format: 'dd/MM/yyyy',
    open: true,
    css: pickerOverride,
    minDate: fromDate ? moment_1["default"](fromDate).format('MM/DD/YYYY') : null,
    disabled: true
  }))));
});

if (utils_1.isDev) {
  exports.DateRangePickerComponent.displayName = 'DateRangePickerComponent';
}

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;